export default {
  // FBA.vue
  fba7: '待购买',
  fba8: '购买完',
  fba9: '待部分销毁',
  fba10: '无法购买',
  packList: '装箱单',
  logisticsCompany: '物流公司',
  logisticsNo: '物流单号',
  line: '线路',
  packBatchNo: '装箱批次号',
  packing: '装箱中',
  finishBox: '装箱完',
  toPay: '待支付',
  toUploadInvoice: '待传发票',
  toSend: '待发送',
  sent: '已发送',
  cancelled: '已取消',
  toPack: '待装箱',
  airTransportation: '空运',
  landTransportation: '陆运',
  createPackList: '新建装箱单',
  packDetail: '装箱详情',
  pay: '支付',
  bill: '账单',
  orderNo: '订单编号',
  goodsName: '商品名',
  orderState: '订单状态',
  warehouseRetention: '是否免费仓储',
  goodsNumber: '商品数量',
  productName: '品名',
  packingNumber: '待装箱数',
  canBoxCount: '可装箱数',
  canApplyCount: '可申请数',
  badToHandle: '不良待处理',
  exchanging: '换货中',
  reissuing: '补发中',
  toWarehouse: '等待到库',
  warehoused: '到库',
  sampling: '检品中',
  sampled: '检品完',
  inStorage: '仓库保管中',
  applyForShipment: '申请发货',
  badReject: '不良驳回',
  exchangeToReturn: '换货待发回',
  exchangeToArrival: '换货等待到货',
  toPartiallyReturned: '待部分退货',
  reissueToArrival: '补发等待到货',
  returnApplying: '退货申请中',
  returnToPay: '退货待支付',
  toReturn: '待退货',
  returned: '已退货',
  destroyToApply: '销毁申请中',
  destroyToPay: '销毁待支付',
  destroyed: '已销毁',
  destroyNumber: '销毁数量',
  returnNumber: '退货数量',
  packNumber: '装箱数量',
  applyNumber: '申请数量',
  confirmCancelPackList: '确定要取消装箱单吗？',
  // FBAFill.vue
  billNo: '账单编号',
  orderType: '订单类型',
  project: '项目',
  price: '单价',
  number: '数量',
  discount: '优惠/折扣',
  amount: '金额',
  totalAmount: '付款总金额',
  totalAmount1: '付款总金额',
  totalAmountjP: '付款总金额(円)',
  currentBalance: '当前余额',
  payNow: '立即支付',
  rechargeTip: '余额不足，请先充值',
  toRecharge: '去充值',
  confirmPay: '确认支付订单吗?',
  // FBAContainerOrder.vue
  addGoods: '新增商品',
  storage: '是否免费仓储',
  address: '收件地址',
  sendAddress: '进口商地址',
  domesticWaybillNo: '国内运单号',
  simple: '检品',
  // submitAfterHandle: '请填写内容或者选择商品之后再提交',
  // BoxList.vue
  packNo: '箱号',
  stocktakeState: '盘点状态',
  unstocktake: '盘点未完成',
  stocktaked: '盘点完成',
  solidWeight: '实重',
  throwingWeight: '抛重',
  bagNumber: '袋数',
  movePack: '移箱',
  movedPackNo: '被移箱号',
  targetBatchNo: '目标批次号',
  mergePack: '合箱',
  mergedPackNo: '被合箱号',
  targetPackNo: '目标箱号',
  selectTargetBatch: '请选择目标批次',
  // BoxOrderList.vue
  notStocktake: '未盘点',
  stocktakeResolve: '盘点通过',
  stocktakeReject: '盘点未通过',
  packDate: '装箱日',
  packPerson: '装箱人',
  orderDate: '下单日',
  color: '颜色',
  size: '尺寸',
  fba1: '发票',
  fba2: '发送日',
  fba3: '箱数',
  fba4: '进口商邮编',
  fba5: '进口商信息',
  batchNo: '批次号',
  boxCount: '箱子数',
  totalGoods: '商品与检品费',
  totalNetWeight: '商品总净重',
  totalRealWeight: '总实重',
  totalThrowWeight: '总抛重',
  goodsNetWeight: '商品净重',
  boxRealWeight: '箱子实重',
  boxThrowWeight: '箱子抛重',
  netWeight: '净重',
  fba11: "编号",
  fbaa1: '※装箱单商品一览表。',
  fbaa2: '※这些费用会在订单处理过程中自动扣除。',
  fbaa3: '※仓库保管费在批次发送时才自动扣除。',
  fbaa4: '※不包含个别信息中有追加发送委托的项目。',
  billDownLoad: '明细下载',
  boxDownLoad: '明细下载',
  downLoad1: "下载中",
  downLoad2: "下载完毕",
  downLoad3: "运输箱包装明细",
};
